/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class ActionRequestSymptomService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'Symptom\' loaded');
    }
}

export { ActionRequestSymptomService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/actionrequest/service/ActionRequestSymptomService.js